module.exports = __webpack_public_path__ + "static/media/icn-search-grey.47459a0a.svg";